import styled, { css } from 'styled-components';
import { LANDING_PLACEMENT } from 'src/commons/components/LandingAppIcon/LandingAppIcon';
import {
  IconButton,
  isDarkThemeMixin,
  styleMixinFocusOutline,
  styleMixinInvertedFocusOutline,
} from '@amzn/storm-ui';

const headerStyles = css`
  margin-inline-start: ${({ theme }) => theme.spacing.xxsmall.default};

  svg {
    font-size: 1rem;
  }

  &&& {
    color: ${({ theme }) => theme.icon.color.inverted};

    :hover,
    :active {
      background-color: ${({ theme }) => theme.color.gray[1000]};
    }

    :hover {
      color: ${({ theme }) => theme.icon.color.invertedHover};
    }

    :active {
      color: ${({ theme }) => theme.icon.color.invertedActive};
    }

    :focus-visible {
      ${styleMixinInvertedFocusOutline};
    }
  }

  ${isDarkThemeMixin(css`
    &&& {
      color: ${({ theme }) => theme.icon.color.default};

      :hover {
        color: ${({ theme }) => theme.icon.color.secondary};
      }

      :active {
        color: ${({ theme }) => theme.icon.color.tertiary};
      }

      :focus-visible {
        ${styleMixinFocusOutline};
      }
    }
  `)};
`;

const sidenavStyles = css`
  width: 40px;
  height: 40px;
  border-radius: ${({ theme }) => theme.border.radius.medium};
  margin-inline-start: ${({ theme }) => theme.spacing.xxxxsmall.default};

  &&& {
    color: ${({ theme }) => theme.icon.color.default};

    :hover {
      color: ${({ theme }) => theme.icon.color.secondary};
    }

    // This icon renders inside the accordion's overflow:hidden collapse grid,
    // which clips an outward outline. Draw a rounded focus ring on an inset
    // ::after overlay (StormUI's focusPseudoElementsAfter strategy) so it is
    // not clipped and follows the button's border-radius.
    position: relative;

    :focus-visible {
      outline: none;

      ::after {
        content: '';
        position: absolute;
        inset: 0;
        border: ${({ theme }) => theme.border.focus.default};
        border-radius: ${({ theme }) => theme.border.radius.medium};
        pointer-events: none;
        z-index: 1;
      }
    }
  }
`;

export const LandingAppIconButton = styled(IconButton)<{
  placement: LANDING_PLACEMENT;
}>`
  ${({ placement }) =>
    placement === LANDING_PLACEMENT.HEADER ? headerStyles : sidenavStyles};
`;
